<template>
  <v-select
    id="axis-select"
    v-model="filter.tema"
    item-text="nome"
    item-value="temaId"
    :items="axis"
    :label="name || 'Temas'"
    placeholder="Temas"
    :return-object="true"
    multiple
    @change="$emit('change', filter.tema)"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.tema.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <span v-if="index < maxDisplay"
        >{{ item.nome
        }}{{
          index === 0 && filter.tema && filter.tema.length > 1 ? "," : ""
        }}
        &nbsp;</span
      >
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.tema.length - maxDisplay }} temas)</span
      >
    </template>

    <template slot="no-data"> Nenhum tema retornado </template>
  </v-select>
</template>

<script>
import { temaAPI } from "../API/temaAPI";

export default {
  name: "AppAxisByProjectCombobox",
  props: ["filter", "name"],
  mounted() {
    this.loadAxis();
  },
  methods: {
    loadAxis() {
      temaAPI
        .list()
        .then((resp) => {
          this.axis = resp.data;
        })
        .catch();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.tema = [];
        } else {
          this.filter.tema = this.axis.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.tema.length === this.axis.length;
    },
    likesSome() {
      return this.filter.tema.length > 0 && !this.axis;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      axis: [],
    };
  },
};
</script>
